import moment from "moment";

export class HighChartsService {

    static $inject = ["$q", "$timeout"];

    constructor(
        private $q: angular.IQService,
        private $timeout: angular.ITimeoutService) {
    }

    getStandardAngularChartOptions(title?: string, onReadyCallback?: (chartObject: Highcharts.ChartObject) => void): Highcharts.Options {
        const highchartsOptions = this.getStandardChartOptions();
        highchartsOptions.chart.alignTicks = false;

        return highchartsOptions;
    }

    addZone(series: Highcharts.SeriesChart, value: number, color?: string, fillColor?: string) {
        series.zones = series.zones || [];

        let areaZone: Highcharts.AreaZone = {
            color: color,
            fillColor: fillColor
        };

        if (value) {
            areaZone.value = value;
        }

        series.zones.push(areaZone);
    }

    addYAxisPlotBand(yAxisOptions: Highcharts.AxisOptions,
        from: number,
        to: number,
        backgroundColor: string,
        borderColor: string,
        label: string,
        fit = false): Highcharts.PlotBands {

        let band: Highcharts.PlotBands = {
            color: backgroundColor,
            borderWidth: 1,
            borderColor: borderColor
        };

        if (from !== undefined) {
            band.from = from;
        }

        if (to !== undefined) {
            band.to = to;
        }

        //const yAxisOptions = (this.tempChartConfig.options.yAxis[0] as Highcharts.AxisOptions);

        if (fit) {
            const yAxisPadding = 3;
            const paddedFrom = from - yAxisPadding;
            const paddedTo = to + yAxisPadding;
            yAxisOptions.min = isNaN(yAxisOptions.min) ? paddedFrom : Math.min(yAxisOptions.min, paddedFrom);
            yAxisOptions.max = isNaN(yAxisOptions.max) ? paddedTo : Math.max(yAxisOptions.max, paddedTo);
        }

        yAxisOptions.plotBands.push(band);

        return band;
    }

    addOrUpdateSeriesDataValue(series: Highcharts.IndividualSeriesOptions, timestamp: string | moment.Moment, value: number) {
        const timestampValue = moment(timestamp).valueOf();

        series.data.push([timestampValue, value]);
    }

    // ------------------------------------------------------------

    private getStandardChartOptions(): Highcharts.Options {
        const highchartsOptions: Highcharts.Options = {
            chart: {
                spacingTop: 10,
                spacingBottom: 5,
                backgroundColor: "transparent",
                plotBackgroundColor: "#fff",
                plotBorderWidth: 1,
                plotBorderColor: "rgba(0,0,0,0.12)",
                zoomType: "x",
                resetZoomButton: {
                    theme: {}
                }
            },
            credits: {
                enabled: false
            },
            legend: {
                enabled: true,
                align: "right",
                verticalAlign: "top",
                itemMarginTop: -5
            },
            colors: ["#00426a", "#cf4946", "#555555", "#90ED7D"],
            plotOptions: {
                line: {
                    marker: {
                        enabled: false, // disable for simplified view
                        radius: 2
                    },
                    lineWidth: 1,
                    states: {
                        hover: {
                            lineWidth: 1
                        }
                    }
                },
                areaspline: {
                    fillOpacity: 0.3,
                    lineWidth: 1,
                    states: {
                        hover: {
                            lineWidth: 1
                        }
                    },
                    marker: {
                        enabled: false, // disable for simplified view
                        radius: 2
                    },
                    zoneAxis: "x",
                    zones: []
                },
                spline: {
                    lineWidth: 1,
                    marker: {
                        enabled: false
                    },
                    states: {
                        hover: {
                            lineWidth: 1,
                            marker: {
                                enabled: false
                            }
                        }
                    },
                    dashStyle: "longdash"
                },
                series: {}
            },
            title: null,
            tooltip: {
                crosshairs: true,
                shared: true,
                formatter: () => { return false; } // disables tooltip but keeps crosshair
            },
            xAxis: {
                type: "datetime",
                title: {
                    text: null // disables title
                },
                plotBands: []
            },
            yAxis: [],
            exporting: {
                enabled: false
            }
        };

        return highchartsOptions;
    }
}
